type ScrollToAnchorOptions = {
  highlightClass?: string;
  highlightMs?: number;
};

/** Smooth-scroll to an element and briefly highlight it (PDP anchors). */
export function scrollToAnchor(
  anchor: string,
  {
    highlightClass = 'highlight-border-active',
    highlightMs = 2000
  }: ScrollToAnchorOptions = {}
): void {
  const targetElement = document.querySelector(anchor);
  if (!targetElement) return;

  targetElement.classList.add(highlightClass);

  const elementRect = targetElement.getBoundingClientRect();
  const elementTop = elementRect.top + window.scrollY;
  const elementHeight = (targetElement as HTMLElement).offsetHeight;
  const windowHeight = window.innerHeight;
  const scrollToPosition = elementTop - (windowHeight / 2) + (elementHeight / 2);

  window.scrollTo({
    top: Math.max(0, scrollToPosition),
    behavior: 'smooth'
  });

  setTimeout(() => {
    targetElement.classList.remove(highlightClass);
  }, highlightMs);
}
